<template>
  <transition name="fade">
    <div
      v-if="show"
      ref="modal"
      class="modal"
    >
      <div
        class="modal__backdrop"
        @click="closeModal()"
      />
      <div class="modal__dialog">
        <div class="modal__header">
          <slot name="header" />
          <button
            type="button"
            class="modal__close"
            aria-label="Close Modal"
            @click="closeModal()"
          >
            <img
              src="/img/icon/close.svg"
              alt="Close"
            >
          </button>
        </div>
        <focus-lock>
          <div class="modal__body">
            <slot name="body" />
          </div>

          <div class="modal__footer">
            <slot name="footer" />
          </div>
        </focus-lock>
      </div>
    </div>
  </transition>
</template>

<script>
import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks,
} from 'body-scroll-lock';

export default {
  name: 'Modal',

  data() {
    return {
      show: false,
    };
  },
  methods: {
    closeModal() {
      this.show = false;
      document.querySelector('body').classList.remove('modal__overflow-hidden');
      enableBodyScroll(document.body);
    },
    openModal() {
      this.show = true;
      document.querySelector('body').classList.add('modal__overflow-hidden');
      disableBodyScroll(document.body);
      clearAllBodyScrollLocks(document.body);
    },
  },
};
</script>
